export default "__VITE_ASSET__CUsn4acq__"